import React, { useEffect } from 'react';
import './App.css';
import Home from './views/Home';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';

// Componente para actualizar <html lang="..."> dinámicamente
function HtmlLanguageSync({ children }: { children: React.ReactNode }) {
  const { language } = useLanguage(); // 'es' | 'en'

  useEffect(() => {
    const html = document.documentElement;
    html.setAttribute('translate', 'no');        // protege contra Google Translate
    html.setAttribute('lang', language || 'en'); // SEO + accesibilidad
  }, [language]);

  return <>{children}</>;
}

function App() {
  return (
    <LanguageProvider>
      <HtmlLanguageSync>
        <div className="App">
          <Home />
        </div>
      </HtmlLanguageSync>
    </LanguageProvider>
  );
}

export default App;
